export const query_releaseNotes = `
query getReleaseNotes {
  releasenotes {
    Id
    Version
    Date
    Pdf
  }
}`;